export const PATHS = {
ROOT: "",


FINANCIAL_YEARS: "FinancialYears",
CREDIT_CARD_SETTINGS: "credit-card-settings",
PROFILE: "profile",



//stores
STORES: "stores",

//documents




VACATION_TYPE: "HRManagement/EmployeesManagement/vaction-type",
VACATION_REQUEST: "HRManagement/EmployeesManagement/vaction-request",
QUALIFICATION: "HRManagement/EmployeesManagement/qualification",
LEAVE_REQUEST: "HRManagement/EmployeesManagement/leave-request",
LEAVE_TYPE: "HRManagement/EmployeesManagement/leave-type",

LEAVE_INQUIRE: "HRManagement/EmployeesManagement/leave-request-inquire",
VACATION_INQUIRE: "HRManagement/EmployeesManagement/vaction-request-inquire",
LEAVE_REPORT: "HRManagement/EmployeesManagement/leave-requeste-report",
VACATION_REPORT: "HRManagement/EmployeesManagement/vaction-requeste-report",

EMPLOYEES: "HRManagement/EmployeesManagement/employees",
EMPLOYEES_BASE_FILTER:"HRManagement/EmployeesManagement/employee-basic-filter",

EMPLOYEES_JOB_FILTER: "HRManagement/EmployeesManagement/employee-Job-filter",
EMPLOYEES_REPORT: "HRManagement/EmployeesManagement/employee-report",
SPECIALIZATIONS: "HRManagement/EmployeesManagement/specializations",



CUSTOMER_RECEIVABLE: "financial-management/customer-receivable",

SUPPLIER_PAYABLE: "financial-management/supplier-payable",
PAYMENT_VOUCHER: "financial-management/payment-voucher",
RECEIPT_VOUCHER: "financial-management/receipt-voucher",

//---- new pages

//financel mangment 

      //  Homepage: "charts",
        Homepage: "DashboardStatistics",
        //FinancialDashboardStatistics: "dashboard/FinancialDashboardStatistics",
        FinancialDashboardStatistics: 'FinancialDashboardStatistics',

        GENERAL_LEDGER: "general-Ledger",
        CASH_AND_BANKS: "Cash-and-Banks",
        BANK_RECONCILIATION: "bank-reconciliation",
        RECEIVABLE: "Receivable",
        PAYABLE: "Payable",
        Fixed_Assets: "Fixed-Assets",
        FINANCIAL_SETTINGS: "Financial-Settings",

//hr managment

        HR: "hr",
        JOB_MANAGEMENT: "JobManagement",
        APPLICATIONS: "Applications",
        HR_INTERVIEWS: "Interviews",
        JOB_OFFER: "JobManagement/job-offer",
        CONTRACTS: "Contracts",
        EMPLOYEES_MANAGEMENT: "EmployeesManagement",
        SALARY_AND_WAGES: "SalaryAndWages",
        ATTENDANCE: "attendance-management",

// Project Management

        PROJECTS: "ProjectsManagement",

//CRM

        sales_management: "sales-management",

//documents management

        DOCUMENTS_MANAGEMENT: "document-management",
        DOCUMENTS: "documents",
        DOCUMENTS_TYPE: "document-type",


//company mangment

        COMPANY_MANGMENT: "Companymangment",
        Subscription_nvoice: 'Subscription-invoice/:id',


 //settings
        COMPANY_BRANCHES: ":id/branches", //frombackend
        DEPARTMENTS: "Departments",
        ROLES: "roles",
        COMPANY_RELIGIONS: "company-religions", // Settings screen added by migration CompanyReligions
        COMPANY_VOUCHER_TYPES: "company-voucher-types", // Settings screen added by migration CompanyVoucherTypesScreen
        COMPANY_FINANCIAL_YEARS: ":id/financial-years",
        Tax_Type:"TaxType",
        My_Subscription: ':id/Subscription',

        SETTINGS: 'settings',
        VOUCHER_TYPES: "VoucherTypes",
        RELIGION_MANAGMENT: "ReligionManagement",
        SUBSCRIPTION_PLAN: "Companymangment/:id/SubscriptionPlan",
        CHANGE_PASSWORD: "change-password-form",

// super-admin console
        SUPER_ADMIN_ROOT: "super-admin",
        SUPER_ADMIN_HOME: "super-admin/home",
        SUPER_ADMIN_COMPANIES: "super-admin/tenancy/companies",
        SUPER_ADMIN_SUBSCRIPTIONS: "super-admin/tenancy/subscriptions",
        SUPER_ADMIN_PLANS: "super-admin/tenancy/plans",
        SUPER_ADMIN_INVOICES: "super-admin/tenancy/invoices",
        SUPER_ADMIN_PAYMENTS: "super-admin/tenancy/payments",
        SUPER_ADMIN_ROLES: "super-admin/access/roles",
        SUPER_ADMIN_PERMISSIONS: "super-admin/access/permissions",
        SUPER_ADMIN_SYSTEMS: "super-admin/access/systems",
        SUPER_ADMIN_AUDIT_LOG: "super-admin/access/audit-logs",
        SUPER_ADMIN_OPERATIONAL_EVENTS: "super-admin/operations/events",
        SUPER_ADMIN_JOBS: "super-admin/operations/jobs",
        SUPER_ADMIN_DATA_RECOVERY: "super-admin/operations/data-recovery",
        SUPER_ADMIN_SUPPORT: "super-admin/operations/support",
        SUPER_ADMIN_LEGAL: "super-admin/settings/legal",
        SUPER_ADMIN_PAYMENT_GATEWAYS: "super-admin/settings/payment-gateways",
        SUPER_ADMIN_PLATFORM_ADMINS: "super-admin/access/platform-admins",
        SUPER_ADMIN_PLATFORM_ROLES: "super-admin/access/platform-roles",
        SUPER_ADMIN_SETTINGS_SYSTEMS: "super-admin/settings/systems",
        SUPER_ADMIN_SETTINGS_PERMISSIONS: "super-admin/settings/permissions",
        SUPER_ADMIN_SUBSCRIPTION_REQUESTS: "super-admin/tenancy/subscription-requests",
        SUPER_ADMIN_SETTINGS_VOUCHER_TYPES: "super-admin/settings/voucher-types",
        SUPER_ADMIN_SETTINGS_RELIGIONS: "super-admin/settings/religions",
        SUPER_ADMIN_SETTINGS_MACHINE_TYPES: "super-admin/settings/machine-types",
        SUPER_ADMIN_SETTINGS_SUBSCRIPTION_PLANS: "super-admin/settings/subscription-plans",
        SUPER_ADMIN_SETTINGS_COUNTRIES: "super-admin/settings/countries",
        SUPER_ADMIN_SETTINGS_PRICING: "super-admin/settings/pricing",
        SUPER_ADMIN_SETTINGS_PRICING_SERVICES: "super-admin/settings/pricing-services",
};
